import { makeStyles } from '@material-ui/core/styles';
import { colorMap } from '@/utils/constants';

const verticalOrientation = {
  bgVideo: {
    width: 'auto',
    height: '100%',
  },
  sixteenNine: {
    '&.MuiSvgIcon-root': {
      width: 'auto',
      height: '100%',
    },
  },
};

const horizontalOrientation = {
  bgVideo: {
    width: '100%',
    height: 'auto',
  },
  sixteenNine: {
    '&.MuiSvgIcon-root': {
      width: '100%',
      height: 'auto',
    },
  },
};

const useStyles = makeStyles(
  {
    video: {
      position: 'relative',
      paddingBottom: '56.25%' /* 16:9 */,
      backgroundColor: colorMap.black,
      overflow: 'hidden',
      width: '100%',

      '& > *': {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
      },

      '&.is-custom > *': {
        width: '101%',
        height: '101%',
      },
    },
    bgVideoContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    bgVideo: {
      '&.vertical-orientation': verticalOrientation.bgVideo,
      '&.horizontal-orientation': horizontalOrientation.bgVideo,
      position: 'absolute',
      backgroundColor: colorMap.black,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      minWidth: '100%',

      '& > *:not(.MuiSvgIcon-root)': {
        position: 'absolute',
        top: '0',
        left: '0',
      },
    },
    youtubeVideo: {
      width: '100%',
      height: '100%',
    },
    customVideo: {
      // width: '100%',
      minWidth: '100%',
      width: 'auto',
      height: '100%',
      left: '50% !important',
      transform: 'translateX(-50%)',
    },
    overlay: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: 2,
    },
    sixteenNine: {
      '&.vertical-orientation': verticalOrientation.sixteenNine,
      '&.horizontal-orientation': horizontalOrientation.sixteenNine,
    },
    fallbackImage: {
      position: 'absolute!important' as 'absolute',
    },
  },
  { name: 'GenVideo' },
);

export default useStyles;
